import React from 'react'

interface HeaderProps {
  width?: number
  height?: number
  stopColor1?: string
  stopColor2?: string
  stopColor3?: string
  stopColor4?: string
}

const Header: React.FC<HeaderProps> = ({
  width = 360,
  height = 80,
  stopColor1 = '#679AE7',
  stopColor2 = '#395DDF',
  stopColor3 = '#811362',
  stopColor4 = '#6634F2',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} fill="#0B2955" />
    <defs>
      <filter
        id="filter0"
        x="-298"
        y="-224"
        width="834"
        height="831"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="102" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="filter1"
        x="72"
        y="-119"
        width="570"
        height="569"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="74" result="effect1_foregroundBlur" />
      </filter>
      <radialGradient
        id="paint0"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform={`translate(${width + 3} ${
          height + 26.5
        }) rotate(-158.257) scale(364.427 336.372)`}
      >
        <stop stopColor={stopColor1} />
        <stop offset="1" stopColor={stopColor2} stopOpacity="0.67" />
      </radialGradient>
      <radialGradient
        id="paint1"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform={`translate(${width - 53} ${
          height - 18
        }) rotate(-61.7097) scale(185.678 266.634)`}
      >
        <stop stopColor={stopColor3} stopOpacity="0.87" />
        <stop offset="1" stopColor={stopColor4} stopOpacity="0.67" />
      </radialGradient>
      <clipPath id="clip0">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0)">
      <g style={{ mixBlendMode: 'lighten' }} filter="url(#filter0)">
        <path
          d={`M${width - 28} ${height + 111}C${width - 28} ${
            height + 227.808
          } ${width - 123.363} ${height + 322} ${width - 241} ${height + 322}C${
            width - 358.637
          } ${height + 322} ${width - 454} ${height + 227.308} ${width - 454} ${
            height + 110.5
          }C${width - 454} ${height - 6.30817} ${width - 358.637} ${
            height - 101
          } ${width - 241} ${height - 101}C${width - 123.363} ${height - 101} ${
            width - 28
          } ${height - 39.6918} ${width - 28} ${height + 77.5}Z`}
          fill={`url(#paint0)`}
        />
      </g>
      <g
        style={{ mixBlendMode: 'lighten' }}
        opacity="0.5"
        filter="url(#filter1)"
      >
        <path
          d={`M${width + 112} ${height + 41.5}C${width + 112} ${
            height + 116.887
          } ${width + 50.6633} ${height + 178} ${width - 24} ${height + 178}C${
            width - 99.6633
          } ${height + 178} ${width - 161} ${height + 116.887} ${width - 161} ${
            height + 41.5
          }C${width - 161} ${height - 33.8869} ${width - 99.6633} ${
            height - 95
          } ${width - 24} ${height - 95}C${width + 50.6633} ${height - 95} ${
            width + 112
          } ${height - 33.8869} ${width + 112} ${height + 41.5}Z`}
          fill={`url(#paint1)`}
        />
      </g>
    </g>
  </svg>
)

export default Header
